import React from 'react';
import { useIdleTimeout } from '../../hooks/useIdleTimeout';

/**
 * This component renders nothing but attaches the idle listeners
 * to the application window.
 */
const SessionManager: React.FC = () => {
  useIdleTimeout();
  return null;
};

export default SessionManager;